























































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { Getter } from 'vuex-class';
import moment from 'moment';
// import { DEFAULT_DATE_FORMAT } from '@root/common/config';
// import { debounce } from 'lodash'
import * as _ from 'lodash';
import { thirdUserviplist } from '@/api/system-management/index';
import Utils from '@root/utils/common';
// import { API_SERVER } from '@root/common/config';
import QRCode from 'qrcodejs2';

@Component
export default class ChannelList extends Mixins(TableMixin, TableWidthMixin) {
  queryChannelListDebounce: any = function() {}; // 列表防抖请求
  registrationChannelListOption = Utils.toLabelVal(
    this.$store.state.dictionaries.allDictionaries.cp_third_user_registration_channel
  );
  moment = moment;
  getChannelList(value) {
    let a = [];
    if (value) {
      a = _.filter(this.registrationChannelListOption, function(o) {
        return o.value == value;
      });
      return a.length > 0 ? a[0].label : '--' || '--';
    }
    return '--';
  }
  tableLoading = false; //表单数据loading
  name = '';
  phoneNum = '';
  registrationChannel = '';
  registrationStartTime = '';
  registrationEndTime = '';
  CurrPage = 1;
  pageSize = 10;
  dataTime = [];

  tableData: any[] = []; // 表数据
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '姓名',
        dataIndex: 'name',
        width: 210,
        scopedSlots: { customRender: 'text-ellipse-small' }
      },
      {
        title: '昵称',
        dataIndex: 'nickName',
        width: 210,
        scopedSlots: { customRender: 'text-ellipse-small' }
      },
      {
        title: '手机号',
        dataIndex: 'phoneNumber',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-small' }
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 140,
        // customRender: (text: any) => text || '--'
        // customRender: (text: string) => dictChannelTypeMap[text],
        scopedSlots: { customRender: 'text-ellipse-small' }
      },
      {
        title: '注册渠道',
        dataIndex: 'registrationChannel',
        width: 200,
        scopedSlots: { customRender: 'registrationChannel' }
      },
      {
        title: '注册时间',
        dataIndex: 'registrationTime',
        width: 280,
        scopedSlots: { customRender: 'text-ellipse-small' }
      }
      //   {
      //     title: '操作',
      //     dataIndex: 'operation',
      //     fixed: 'right',
      //     width: 0,
      //     scopedSlots: { customRender: 'operation' }
      //   }
    ];
  }

  onChange(date, dateString) {
    console.log(date, dateString, '---->>>');
    if (date && dateString) {
      this.registrationStartTime = dateString[0];
      this.registrationEndTime = dateString[1];
    }
  }
  // 生命周期初始化表单
  created() {
    this.fetchTableData();
  }

  /**
   * 请求数据列表
   */
  current = 1;
  async fetchTableData(isRefresh?: boolean) {
    if (this.tableLoading) return;
    this.tableLoading = true;
    if (isRefresh) this.current = 1;
    try {
      const { status, code, msg, data } = await thirdUserviplist({
        name: this.name,
        phoneNum: this.phoneNum,
        registrationChannel: this.registrationChannel,
        registrationStartTime: this.registrationStartTime,
        registrationEndTime: this.registrationEndTime,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  //搜索
  searchTableData() {
    this.fetchTableData(true);
  }
  areaId: any;
  // 清空搜索条件
  onTableFilterClear() {
    this.name = '';
    this.phoneNum = '';
    this.registrationChannel = '';
    this.registrationStartTime = '';
    this.registrationEndTime = '';
    this.dataTime = [];
    this.fetchTableData(true);
  }
}
